import { render, staticRenderFns } from "./TierIcon.vue?vue&type=template&id=5a3254a0&"
import script from "./TierIcon.vue?vue&type=script&lang=js&"
export * from "./TierIcon.vue?vue&type=script&lang=js&"
import style0 from "./TierIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSheet,VTooltip})
